import { render, staticRenderFns } from "./DeltaDisplay.vue?vue&type=template&id=2e931d92&"
import script from "./DeltaDisplay.vue?vue&type=script&lang=js&"
export * from "./DeltaDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports